"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _default2 = _interopRequireDefault(require("./default"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fetch = _interopRequireDefault(require("@eig-builder/core-utils/fetch"));

var _useDataApi = require("@eig-builder/core-utils/hooks/useDataApi");

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

var fetchDataFromServer = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
    var fetchConfiguration, cacheKey, cacheObject, data, jsonData;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fetchConfiguration = {
              url: url,
              // taking this one into the cacheKey
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              },
              credentials: 'include'
            }; // 🔐 creat a hash from the config object

            cacheKey = (0, _useDataApi.getCacheKey)(fetchConfiguration);
            cacheObject = (0, _useDataApi.getFromCache)(cacheKey);

            if (!cacheObject) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", cacheObject);

          case 7:
            _context.next = 9;
            return (0, _fetch["default"])(url, fetchConfiguration);

          case 9:
            data = _context.sent;
            _context.next = 12;
            return data.json();

          case 12:
            jsonData = _context.sent;
            // save the data also to the cache, the cache will be cleared on !GET requests by core functions.
            (0, _useDataApi.setCache)(cacheKey, jsonData);
            return _context.abrupt("return", jsonData);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchDataFromServer(_x) {
    return _ref.apply(this, arguments);
  };
}();

var gridDataUrl = function gridDataUrl(url, page, pageSize, orderData, sortData, filterData, query) {
  var searchQuery = query ? "&search_query=".concat(query) : '';
  return "".concat(url, "&page=").concat(page, "&pageSize=").concat(pageSize).concat(orderData).concat(sortData).concat(filterData).concat(searchQuery);
};

var parseSortData = function parseSortData(sortModel) {
  var queryParameter = '&sort=';
  var queryString = sortModel === null || sortModel === void 0 ? void 0 : sortModel.reduce(function (string, _ref2) {
    var colId = _ref2.colId,
        sort = _ref2.sort;
    string += "".concat(colId, "_").concat(sort);
    return string;
  }, queryParameter);
  return queryString === queryParameter ? '' : queryString;
};

var parseFilterData = function parseFilterData(filter) {
  var filterQuery = JSON.stringify(filter).replace(/[{}]|"/g, "");
  var queryString = "&filter=".concat(filterQuery);
  return filter ? queryString : '';
};

var parseOrderBy = function parseOrderBy(sortModel) {
  if (sortModel) {
    var queryParameter = '&order_by=';
    var queryString = sortModel.reduce(function (string, _ref3) {
      var colId = _ref3.colId,
          sort = _ref3.sort;
      var isDesc = sort === 'desc';
      string += "".concat((0, _snakeCase["default"])(colId), "&order_by_descending=").concat(isDesc);
      return string;
    }, queryParameter);
    return queryString === queryParameter ? '' : queryString;
  }
};

var GridWithPagination = function GridWithPagination(_ref4) {
  var paginationPageSize = _ref4.paginationPageSize,
      url = _ref4.url,
      onGridReady = _ref4.onGridReady,
      onDataUpdate = _ref4.onDataUpdate,
      dataProp = _ref4.dataProp,
      totalProp = _ref4.totalProp,
      infinite = _ref4.infinite,
      tableHeight = _ref4.tableHeight,
      _forceDataUpdate = _ref4.forceDataUpdate,
      restProps = (0, _objectWithoutProperties2["default"])(_ref4, ["paginationPageSize", "url", "onGridReady", "onDataUpdate", "dataProp", "totalProp", "infinite", "tableHeight", "forceDataUpdate"]);
  var api = (0, _react.useRef)();
  var gridApi;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      filter = _useState2[0],
      setFilter = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      serverData = _useState4[0],
      setServerData = _useState4[1];

  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  infinite = isMobile || infinite;
  var rowModelType = infinite ? 'infinite' : 'serverSide';

  var gridReady = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(gridParams) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              gridApi = gridParams.api;
              api.current = gridParams.api;

              if (infinite) {
                gridApi.setDatasource(datasource);
              } else {
                gridApi.setServerSideDatasource(datasource);
              }

              onGridReady(gridParams);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function gridReady(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (api.current) {
      if (infinite) {
        api.current.setDatasource(datasource);
      } else {
        api.current.setServerSideDatasource(datasource);
      }
    }
  }, [filter]);

  var getCurrentPage = function getCurrentPage(params, noGridApi) {
    // noGridApi : gridApi from ag-grid is not available
    if (infinite) {
      return params.request.endRow / paginationPageSize;
    } else if (!noGridApi) {
      return params.request.endRow / paginationPageSize;
    }

    return gridApi.paginationProxy.currentPage + 1;
  };

  var getTotalOrLast = function getTotalOrLast(gridData, params) {
    if (infinite) {
      return gridData[totalProp] <= params.request.endRow ? gridData[totalProp] : -1;
    }

    return gridData[totalProp];
  };

  var getTableHeight = function getTableHeight() {
    if (infinite) {
      return tableHeight;
    }

    return undefined;
  };

  var datasource = {
    /**
     * Function which is called after changing a filter in the grid navigation
     * @param {object} filters - Current Filter on the grid
     */
    onFilterChanged: function () {
      var _onFilterChanged = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(filter) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                setFilter(filter);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function onFilterChanged(_x3) {
        return _onFilterChanged.apply(this, arguments);
      }

      return onFilterChanged;
    }(),

    /**
     * Function which is called by AG-grid or the custom view to get new per page
     * @param {object} params - Object which includes current page info
     */
    getRows: function () {
      var _getRows = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(params) {
        var _gridApi, _gridApi2, _serverDataResponse$d;

        var loading, filterBy, sortBy, orderBy, searchQuery, serverDataResponse, _params$parentNode, _params$parentNode$gr, _params$parentNode$gr2;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loading = true;
                onDataUpdate({
                  loading: loading,
                  rowCount: null
                });
                filterBy = parseFilterData(filter); // Sorting model is used by outdated pagination

                sortBy = parseSortData((_gridApi = gridApi) === null || _gridApi === void 0 ? void 0 : _gridApi.getSortModel()); // Order model is used by new pagination to do orderning on columns

                orderBy = parseOrderBy((_gridApi2 = gridApi) === null || _gridApi2 === void 0 ? void 0 : _gridApi2.getSortModel()); // Search query

                searchQuery = params.parentNode ? params.parentNode.context.query : ''; // Fetch data from server with parameters: sort, order and search (TODO: filtering)

                _context4.next = 8;
                return fetchDataFromServer(gridDataUrl(url, getCurrentPage(params, !!gridApi) || 1, paginationPageSize, orderBy !== null && orderBy !== void 0 ? orderBy : '', sortBy || '', filterBy, searchQuery));

              case 8:
                serverDataResponse = _context4.sent;
                // Update serverData state
                setServerData(serverDataResponse); // SuccessCallback is called to set new data in grid

                params.successCallback(serverDataResponse[dataProp], getTotalOrLast(serverDataResponse, params));
                loading = false;

                if (!((_serverDataResponse$d = serverDataResponse[dataProp]) === null || _serverDataResponse$d === void 0 ? void 0 : _serverDataResponse$d.length)) {
                  (_params$parentNode = params.parentNode) === null || _params$parentNode === void 0 ? void 0 : (_params$parentNode$gr = _params$parentNode.gridApi) === null || _params$parentNode$gr === void 0 ? void 0 : _params$parentNode$gr.showNoRowsOverlay();
                } // Update onData which is a callback and can be used outside the grid


                onDataUpdate({
                  loading: loading,
                  rowCount: serverDataResponse[totalProp]
                }); // AG-grid extra: size columns to fit

                if (params.parentNode) {
                  (_params$parentNode$gr2 = params.parentNode.gridApi) === null || _params$parentNode$gr2 === void 0 ? void 0 : _params$parentNode$gr2.sizeColumnsToFit();
                }

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getRows(_x4) {
        return _getRows.apply(this, arguments);
      }

      return getRows;
    }()
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_default2["default"], (0, _extends2["default"])({
    paginationPageSize: paginationPageSize,
    cacheBlockSize: paginationPageSize,
    pagination: !infinite,
    gridData: serverData,
    serverSidePagination: true,
    onGridReady: gridReady,
    datasource: datasource,
    rowModelType: rowModelType,
    tableHeight: getTableHeight(),
    forceDataUpdate: function forceDataUpdate(func) {
      return _forceDataUpdate(func);
    }
  }, restProps)));
};

GridWithPagination.propTypes = {
  url: _propTypes["default"].string.isRequired,
  forceDataUpdate: _propTypes["default"].func,
  paginationPageSize: _propTypes["default"].number,
  onGridReady: _propTypes["default"].func,
  onDataUpdate: _propTypes["default"].func,
  dataProp: _propTypes["default"].string,
  totalProp: _propTypes["default"].string,
  infinite: _propTypes["default"].bool,
  tableHeight: _propTypes["default"].any
};
GridWithPagination.defaultProps = {
  paginationPageSize: 20,
  dataProp: 'data',
  totalProp: 'total_count',
  infinite: false,
  tableHeight: '600px',
  forceDataUpdate: function forceDataUpdate() {},
  onGridReady: function onGridReady() {},
  onDataUpdate: function onDataUpdate() {}
};

var _default = (0, _react.memo)(GridWithPagination);

exports["default"] = _default;